import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import { deleteUserFromApartment } from "../../services/apartmentService";
import SuccessMessageModal from "../Reusable/SuccessMessageModal";
import WarningMessageModal from "../Reusable/WarningMessageModal";

const DeleteUsuarioModal = ({ isOpen, onClose, userAssociation, onUserDeleted }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const handleConfirm = async () => {
    if (!userAssociation || !userAssociation.id) {
      setModalMessage("No se ha proporcionado una asociación de usuario válida.");
      setIsWarningOpen(true);
      return;
    }

    setIsLoading(true);
    try {
      await deleteUserFromApartment(userAssociation.id);
      setModalMessage("Usuario desvinculado del apartamento exitosamente.");
      setIsSuccessOpen(true);
      onClose(); // Cierra el modal de confirmación
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Error al desvincular el usuario.";
      setModalMessage(errorMessage);
      setIsWarningOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSuccessClose = () => {
    setIsSuccessOpen(false);
    onUserDeleted();
  };

  return (
    <>
      <Dialog open={isOpen} onClose={onClose}>
        <DialogTitle>Eliminar Usuario del Apartamento</DialogTitle>
        <DialogContent>
          {isLoading ? (
            <Box display="flex" justifyContent="center"><CircularProgress /></Box>
          ) : (
            <Typography>
              ¿Estás seguro de que deseas desvincular al usuario{" "}
              <strong>{userAssociation ? userAssociation.username : ""}</strong> de este apartamento?
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button onClick={handleConfirm} color="error" variant="contained" disabled={isLoading}>
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
      <SuccessMessageModal isOpen={isSuccessOpen} message={modalMessage} onClose={handleSuccessClose} />
      <WarningMessageModal isOpen={isWarningOpen} message={modalMessage} onClose={() => setIsWarningOpen(false)} />
    </>
  );
};

export default DeleteUsuarioModal;
